<div class="error-list">
  <ul class="error-messages" *ngIf="errorList">
    <div>
      <li *ngFor="let error of errorList">
        <div class="alert alert-danger icons-alert">
          <button
            appRemoveAlert
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <i class="icofont icofont-close-line-circled"></i>
          </button>
          <p>
            <code>{{ error }}</code>
          </p>
        </div>
      </li>
    </div>
  </ul>
</div>
